import axios from 'axios';
export default {
    get(context, endpoint){ 
        return new Promise((resolve,reject)=>{
            var api_token = localStorage.getItem('api_token');
            axios.get(endpoint+'?api_token='+api_token)
            .then((data)=>{
                resolve(data)
            })
            .catch((error)=>{
                console.log('error', error.request); 
                // context.dispatch('checkIfSessionExpired',error);
                reject(error)
            })
        });
    },
    delete(context, endpoint){ 
        return new Promise((resolve,reject)=>{
            var api_token = localStorage.getItem('api_token');
            axios.delete(endpoint+'?api_token='+api_token)
            .then((data)=>{
                resolve(data)
            })
            .catch((error)=>{
                console.log('error', error.request); 
                // context.dispatch('checkIfSessionExpired',error);
                reject(error)
            })
        });
    },
    post(context , data){ 
        return new Promise((resolve,reject)=>{
            var api_token = localStorage.getItem('api_token');
            axios.post(data.endpoint+'?api_token='+api_token , data.details,)
            .then((data)=>{
                resolve(data)
            })
            .catch((error)=>{
                // context.dispatch('checkIfSessionExpired',error);
                reject(error)
            })
        });
    },

    put(context , data){ 
        return new Promise((resolve,reject)=>{
            var api_token = localStorage.getItem('api_token');
            axios.put(data.endpoint+'?api_token='+api_token , data.details,)
            .then((data)=>{
                resolve(data)
            })
            .catch((error)=>{
                // context.dispatch('checkIfSessionExpired',error);
                reject(error)
            })
        });
    },

    login(context , data){ 
        return new Promise((resolve,reject)=>{
            axios.post(data.endpoint , data.details,)
            .then((data)=>{
                resolve(data)
            })
            .catch((error)=>{
                // context.dispatch('checkIfSessionExpired',error);
                reject(error)
            })
        });
    },
}
